import {PageLink} from '../../../_metronic/layout/core'
import {
  formatInputPrice,
  formatPrice,
  formatToIndianNumber,
  isEmpty,
  makeSemicolonSepratedValues,
} from '../../../utils/common'
import {formatDate} from '../../../utils/date'
import {IInquiryDetail} from '../hooks/useInStockNotifyOperations'
import defaultImage from '../../../images/default-bc-product.png'
import {ValidationError} from '../interfaces'
import Papa from 'papaparse'

export const ReplenishmentPageBreadCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Replenishment',
    path: '/analytics/replenishment/dashboard',
    isSeparator: false,
    isActive: true,
  },
]

export const ReorderBreadCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Replenishment',
    path: '/analytics/replenishment/dashboard',
    isSeparator: false,
    isActive: true,
  },
]

export const supplierManagementBreadCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Replenishment',
    path: '/analytics/replenishment/dashboard',
    isSeparator: false,
    isActive: true,
  },
]

export const dataToMultiSelectOptions = (data: any, type: string) => {
  const res: any = []

  if (data?.[type]?.length) {
    data[type].forEach((i: any) => {
      res.push({
        value: i,
        label: i,
      })
    })
  }

  return res
}

export function extractValues(input: any) {
  if (input?.length) {
    return input.map((item: any) => item.value)
  } else {
    return []
  }
}

export function dataToUserSupplierMappingList(data: any) {
  const res: any = []

  if (!data || data.length === 0) {
    return []
  }

  data.forEach((i: any) => {
    res.push({
      id: i['user_id'],
      name: i['user_name'],
      suppliers: i['suppliers'],
    })
  })

  return res
}

export function dataToSuppliersList(data: any) {
  const res: any = []

  if (!data || data.length === 0) {
    return []
  }

  data.forEach((i: any) => {
    res.push({
      label: i['primary_supplier'],
      value: i['primary_supplier'],
    })
  })

  return res
}

export function dataToFormValues(data: any) {
  if (!data) return {}

  const res: any = {
    name: {
      value: data['name'],
      label: data['name'],
    },
    email: data['email_id'],
  }

  const suppliers: any = []

  data['suppliers'].forEach((i: any) =>
    suppliers.push({
      value: i,
      label: i,
    })
  )

  res['suppliers'] = suppliers

  return res
}

function makeCommaSepratedValues(input: any) {
  if (input?.length && Array.isArray(input)) {
    return input.map((item: any) => item.value).join(',')
  } else {
    return ''
  }
}

export const formDataToFiltersValue = (data: any) => {
  return {
    limit: data?.limit || 10,
    brand: makeSemicolonSepratedValues(data?.brands),
    classification: makeSemicolonSepratedValues(data?.classifications),
    primary_supplier: makeSemicolonSepratedValues(data?.primary_supplier),
    search_value: data?.search || '',
    user: data?.name?.value || '',
    sale_history_months: data?.sale_history_months || 6,
    days_to_replenishment: data?.days_to_replenishment || 30,
    days_to_replenishment_45: data?.days_to_replenishment_45 || 30,
    days_to_replenishment_60: data?.days_to_replenishment_60 || 30,
    tags: makeCommaSepratedValues(data?.tags),
    hide_discontinued: data?.hide_discontinued || false,
    show_zero_qty_products: data?.show_zero_qty_products || false,
    no_sold_days: data?.no_sold_days || false,
    ratio_filter: data?.ratio_filter || 'month_6',
    year: data?.year || '',
    classified_as: makeCommaSepratedValues(data?.classified_as),
  }
}

export const formDashboardDataToFiltersValue = (data: any) => {
  return {
    limit: data?.limit || 10,
    brand: makeSemicolonSepratedValues(data?.brands),
    classification: makeSemicolonSepratedValues(data?.classifications),
    primary_supplier: makeSemicolonSepratedValues(data?.primary_supplier),
    search_value: data?.search || '',
    user: data?.name?.value || '',
    sale_history_months: data?.sale_history_months || 6,
    days_to_replenishment: data?.days_to_replenishment || 30,
    days_to_replenishment_45: data?.days_to_replenishment_45 || 30,
    days_to_replenishment_60: data?.days_to_replenishment_60 || 30,
    tags: makeCommaSepratedValues(data?.tags),
    hide_discontinued: data?.hide_discontinued || false,
    show_zero_qty_products: data?.show_zero_qty_products || false,
    no_sold_days: data?.no_sold_days || false,
    ratio_filter: data?.ratio_filter || 'month_6',
    year: data?.year || '',
    classified_as: makeCommaSepratedValues(data?.classified_as),
  }
}

export const formDataToFiltersValueReorder = (data: any) => {
  return {
    primary_supplier: makeSemicolonSepratedValues(data?.primary_supplier),
    user: data?.user?.value || '',
    filter_key: data?.filter_key || '',
    search_value: data?.search || '',
  }
}

export const parseReorderingTableRowData = (row: any) => {
  return {
    sku: row?.sku || '',
    title: row?.title || '-',
    primary_supplier: row?.primary_supplier || '-',
    quantity: row?.quantity || 0,
    total_cost: formatInputPrice(row?.total_cost, true, false) || '',
    quantity_available: row?.quantity_available || '0',
    quantity_incoming: row?.quantity_incoming || '0',
    total_sold_30: row?.total_sold_30 || '0',
    reorder_point: row?.reorder_point || '0',
    incremental_quantity: row?.incremental_quantity || '0',
    suggested_order_qty: row?.suggested_order_qty || '0',
    to_order_qty: row?.to_order_qty || '0',
    cost: formatInputPrice(row?.cost, true, false) || '',
    sale_history_months: row?.sale_history_months || '0',
    days_to_replenishment: row?.days_to_replenishment || '0',
    brand: row?.brand || '',
    classification: row?.classification || '0',
    weeks_on_hand: (row?.weeks_on_hand || 0)?.toFixed(2),
    turn_rate: (row?.turn_rate || 0)?.toFixed(2),
    modified_by: row?.modified_by || '0',
    modified_at: row?.modified_at == null ? '-' : formatDate(row?.modified_at, false),
    thumbnail_url: row?.thumbnail_url || defaultImage,
  }
}

export const parseAggregatedTableRowData = (row: any) => {
  return {
    showAggregatedTable: row?.showAggregatedTable || false,
    product_id: row?.product_id || '',
    title: row?.title || '-',
    primary_supplier: row?.primary_supplier || '-',
    quantity_available: row?.quantity_available || 0,
    quantity_incoming: row?.quantity_incoming || 0,
    total_sold: row?.total_sold || 0,
    reorder_point: row?.reorder_point || '',
    incremental_quantity: row?.incremental_quantity || 0,
    suggested_order_qty: (row?.suggested_order_qty || 0)?.toFixed(2),
    to_order_qty: row?.to_order_qty || 0,
    cost: formatInputPrice(row?.cost, false, false) || '',
    brand: row?.brand || '-',
    classification: row?.classification || '-',
    weeks_on_hand: (row?.weeks_on_hand || 0)?.toFixed(2),
    turn_rate: (row?.turn_rate || 0)?.toFixed(2),
  }
}

export const parseTableRowData = (row: any) => {
  return {
    parent_sku: row?.parent_sku || '-',
    //product_id: row?.product_id || '',
    product_title: row?.product_title || '-',
    primary_supplier: row?.primary_supplier || [],
    quantity_available: row?.quantity_available || 0,
    quantity_incoming: row?.quantity_incoming || 0,
    sale_history_months: row?.sale_history_months || 6,
    days_to_replenishment: row?.days_to_replenishment || 30,
    total_sold_30: row?.total_sold_30 || '-',
    reorder_point: row?.reorder_point || '-',
    incremental_quantity: row?.incremental_quantity || 0,
    suggested_order_qty: row?.suggested_order_qty?.toFixed(2) || 0,
    suggested_order_qty_45: row?.suggested_order_qty_45?.toFixed(2) || 0,
    suggested_order_qty_60: row?.suggested_order_qty_60?.toFixed(2) || 0,
    to_order_qty: row?.to_order_qty || 0,
    item_order_qty: row?.item_order_qty || 0,
    total_quantity:
      (parseInt(row?.quantity_incoming) || 0) + (parseInt(row?.quantity_available) || 0),
    cost: formatInputPrice(row?.cost, true, false) || 'N/A',
    classification: row?.classification || [],
    brand: row?.brand || '-',
    weeks_on_hand: row?.weeks_on_hand?.toFixed(2) || '-',
    turn_rate: row?.turn_rate?.toFixed(2) || '-',
    child_data: row?.child_data || [],
    reserved_quantity: row?.reserved_quantity || '-',
    backorder_quantity: row?.backorder_quantity || 0,
    safetystock_quantity: row?.safetystock_quantity || 0,
    days_out_of_stock: row?.days_out_of_stock || 0,
    total_cost: row?.total_cost || 0,
    unique_classification: row?.unique_classification || null,
    caseQty: row?.case_qty,
    latestPoDate: row?.latest_po_date || '',
    lastReceivedDate: row?.last_received_date || '',
    lastReceivedQuantity: row?.last_received_quantity || '-',
    lastOutOfStockDate: row?.last_out_of_stock_date || '',
    totalOutOfStockDays:
      row?.occurrence_range && row?.occurrence_range !== '0' ? row?.occurrence_range : null,
    expiry_date: row?.expiry_date || null,
    classifiedAs: row?.classified_as || '-',
    rtv_date: row?.rtv_date || null,
    rtv_number: row?.rtv_number || null,
    rtv_status: row?.rtv_status || null,
    quantity: row?.quantity || null,
    total_rtv_quantity: row?.total_rtv_quantity || 0,
    total_product_return: row?.total_zero_quantity || 0,
    totalInstockNotify: row?.total_instock_notify || 0,
    thumbnail_url: row?.thumbnail_url || defaultImage,
  }
}

export const parseDailySoldReportRowData = (row: any) => {
  return {
    parent_sku: row?.parent_sku || '-',
    product_title: row?.product_title || '-',
    reserved_quantity: row?.reserved_quantity ?? '-',
    quantity_available: row?.quantity_available ?? '-',
    quantity_incoming: row?.quantity_incoming ?? '-',
    child_data: row?.child_data || [],
    total_month_quantity: row?.total_month_quantity || '-',
    thumbnail_url: row?.thumbnail_url || defaultImage,
  }
}

export const parseDashboardTableRowData = (row: any) => {
  return {
    product_title: row?.product_title || '-',
    parent_sku: row?.parent_sku || '-',
    primary_supplier: row?.primary_supplier || [],
    purchaser_name: row?.purchaser_name || [],
    classification: row?.classification || [],
    cost: row?.cost || 0,
    quantity_pending: row?.quantity_pending || 0,
    quantity_incoming: row?.quantity_incoming || 0,
    quantity_available: row?.quantity_available || 0,
    quantity_on_hold: row?.quantity_on_hold || 0,
    total_quantity:
      (parseInt(row?.quantity_incoming) || 0) + (parseInt(row?.quantity_available) || 0),
    terms_consignment: row?.terms_consignment || '-',
    action_taken: row?.action_taken || '',
    created_at: row?.created_at ? formatDate(row?.created_at, true) : '-',
    year: row?.year || '-',
    classified_as: row?.classified_as || '',
    total_sold: row?.total_sold || 0,
    ratio: row?.ratio || 0,
    total_cost: formatPrice(row?.total_cost || 0, true),
    wholesale_price: row?.wholesale_price || 0,
    thumbnail_url: row?.thumbnail_url || defaultImage,
  }
}

export const parseTagsTableRowData = (row: any) => {
  return {
    tag: row?.tag || '-',
    productCount: row?.count || 0,
    sku: row?.sku || '-',
    id: row?.id || '',
  }
}

export const parseUserSupplierTableRowData = (row: any) => {
  return {
    name: row?.name || '-',
    suppliers: row?.suppliers || [],
  }
}

export const parseProductTagsTableRowData = (row: any) => {
  return {
    name: row?.product_name || '-',
    tags: row?.tags || [],
    tableSku: row?.variant_sku ? row?.variant_sku : row?.sku || '-',
    option: row?.variant_options || '',
    sku: row?.sku || '',
    variantSku: row?.variant_sku,
  }
}

export const parseInquiryData = (data: any[]): IInquiryDetail[] => {
  if (isEmpty(data)) return []

  return data?.map((item, index) => ({
    id: `${item.customer_email}-${item.created_at}-${index}`,
    customerName: item.customer_name || '',
    email: item.customer_email || '-',
    inquiryDate: item.created_at || '',
    sku: item.sku || '-',
    productName: item.product_name || '-',
    customerGroup: item.customer_group || '-',
    salesRep: item.sales_rep || '-',
    notifyEmail: item.notify_email || '-',
    variantId: item.variant_id?.toString() || null,
  }))
}

export const parseOutOfStockOccurrenceData = (data: any[]): any[] => {
  if (isEmpty(data)) return []

  return data?.map((item) => ({
    childSKU: item.sku || '-',
    outOfStockDate: item.out_of_stock_start_date || null,
    restockDate: item.out_of_stock_end_date || null,
    restockQuantity: item.inventory_level || '-',
  }))
}

export const inquiryDetailsTableColumns = (isParentRow: boolean) => {
  return [
    {
      key: 'inquiry_date',
      label: 'Inquiry Date',
      headerStyle: 'min-w-120px',
    },
    ...(isParentRow
      ? [
          {
            key: 'sku',
            label: 'SKU',
            headerStyle: 'min-w-120px',
          },
        ]
      : []),
    {
      key: 'customer_name',
      label: 'Customer Name',
      headerStyle: 'min-w-175px',
    },
    {
      key: 'sales_rep',
      label: 'Sales Rep',
      headerStyle: 'min-w-125px',
    },
    {
      key: 'notify_email',
      label: 'Notify Email',
      headerStyle: 'min-w-200px',
    },
  ]
}

export const outOfStockOccurrenceDetailsTableColumns = (isParentRow: boolean) => {
  return [
    ...(isParentRow
      ? [
          {
            key: 'sku',
            label: 'Child SKU',
            headerStyle: 'min-w-120px',
          },
        ]
      : []),
    {
      key: 'out_of_stock_date',
      label: 'Out of Stock Date',
      headerStyle: 'min-w-120px',
    },
    {
      key: 'customer_name',
      label: 'Restock Date',
      headerStyle: 'min-w-175px',
    },
    {
      key: 'sales_rep',
      label: 'Restock Quantity',
      headerStyle: 'min-w-125px',
    },
  ]
}

export const sampleProductTagsCSVData = [
  {SKU: 'SKU001', Tags: 'Test Tag 1'},
  {SKU: 'SKU002', Tags: 'Test Tag 2'},
  {SKU: 'SKU003', Tags: 'Test Tag 3'},
]

export const productTagsCsvConfig = {
  requiredHeaders: ['SKU', 'Tags'],
  duplicates: {sku: false, tags: true, rows: true},
  maxRows: 5000,
  isNullable: false,
  isReplaceable: true,
  replacePartially: true,
  transformData: {
    uniqueKey: [{sku: 'sku'}],
    groupedKey: [{tags: 'tags'}],
    specialGroupKey: ',',
  },
  customErrors: {
    headerMismatch: () => 'The CSV file must contain two columns: SKU, Tags',
    invalidFileType: () =>
      `The file you are trying to upload is not in a valid CSV format. Please upload a valid CSV file.`,
    emptyCell: (RowNumber: number, headerName: string) =>
      `The ${headerName} is blank in CSV row number ${RowNumber}.`,
    duplicateWithDefault: (skuName: any, rowNumber: number, headerName: string) =>
      `${headerName}: <strong>${skuName}</strong>, Row No. <strong>${rowNumber}</strong>`,
  },
}

export const sampleBackOrderCSVData = [
  {SKU: 'SKU001', Qty: 10},
  {SKU: 'SKU002', Qty: 20},
  {SKU: 'SKU003', Qty: 30},
]

export const backOrderCsvConfig = {
  requiredHeaders: ['SKU', 'Qty'],
  duplicates: {sku: false},
  isNullable: false,
  isReplaceable: true,
  replacePartially: true,
  maxRows: 5000,
  types: {
    qty: 'integer',
  },
  customErrors: {
    headerMismatch: () => 'The CSV file must contain two columns: SKU, Qty',
    invalidFileType: () =>
      `The file you are trying to upload is not in a valid CSV format. Please upload a valid CSV file.`,
    emptyCell: (RowNumber: number, headerName: string) =>
      `The ${headerName} is blank in CSV row number ${RowNumber}.`,
    duplicateWithDefault: (skuName: any, rowNumber: number, headerName: string) =>
      `${headerName}: <strong>${skuName}</strong>, Row No. <strong>${rowNumber}</strong>`,
    replacePartially:
      'The following SKU(s) already exist in the system. Do you want to proceed with overwriting these data?',
    maxRowsLimit: (currentRows: number, maxLimit: number) =>
      `The current CSV contains ${currentRows} SKUs. The maximum allowed SKUs are ${maxLimit}. Please reduce the number of SKUs to proceed with the import.`,
    invalidDataType: (headerName: string, rowIndex: number) =>
      `Invalid ${headerName} found in rows: ${rowIndex}`,
  },
}

export const sampleSafetyStockCSVData = [
  {SKU: 'SKU001', Qty: 10},
  {SKU: 'SKU002', Qty: 20},
  {SKU: 'SKU003', Qty: 30},
]

export const safetyStockCsvConfig = {
  requiredHeaders: ['SKU', 'Qty'],
  duplicates: {sku: false, rows: true},
  isNullable: false,
  isValidateHeadersDataOnly: false,
  isReplaceable: true,
  replacePartially: true,
  maxRows: 5000,
  types: {
    qty: 'integer',
  },
  customErrors: {
    headerMismatch: () => 'The CSV file must contain two columns: SKU, Qty',
    invalidFileType: () =>
      `The file you are trying to upload is not in a valid CSV format. Please upload a valid CSV file.`,
    emptyCell: (RowNumber: number, headerName: string) =>
      `The ${headerName} is blank in CSV row number ${RowNumber}.`,
    duplicateWithDefault: (skuName: any, rowNumber: number, headerName: string) =>
      `${headerName}: <strong>${skuName}</strong>, Row No. <strong>${rowNumber}</strong>`,
    replacePartially:
      'The following SKU(s) already exist in the system. Do you want to proceed with overwriting these data?',
    maxRowsLimit: (currentRows: number, maxLimit: number) =>
      `The current CSV contains ${currentRows} SKUs. The maximum allowed SKUs are ${maxLimit}. Please reduce the number of SKUs to proceed with the import.`,
    invalidDataType: (headerName: string, rowIndex: number) =>
      `Invalid ${headerName} found in rows: ${rowIndex}`,
  },
}

export function isProductDiscontinued(productTitle: string): boolean {
  if (!productTitle || typeof productTitle !== 'string') return true
  return productTitle.toLowerCase().includes('discontinued')
}

export const toSnakeCase = (str: string) => {
  return str
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/([a-z])([A-Z])/g, '$1_$2') // Add underscore between lowercase and uppercase letters
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2') // Handle acronyms (CBD2Store -> cbd2_store)
    .toLowerCase() // Convert everything to lowercase
}

export const dataToProductTagsCSV = (data: any) => {
  const results: any = []

  data.forEach((item: any) => {
    results.push({
      SKU: `${item?.variant_sku ?? item?.sku}`,
      Tags: `"${item?.tags.join(',') || ''}"`,
    })
  })

  return results
}

export const dataToBackOrderCSV = (data: any) => {
  const results: any = []

  data.forEach((item: any) => {
    results.push({
      SKU: item?.child_sku,
      Qty: item?.qty || 0,
    })
  })

  return results
}

export const dataToSafetyStockCSV = (data: any) => {
  const results: any = []

  data.forEach((item: any) => {
    results.push({
      SKU: item?.child_sku,
      Qty: item?.qty || 0,
    })
  })

  return results
}

export const convertToLabelValue = (data: any) => {
  if (isEmpty(data)) return []
  return data?.map((item: any) => ({
    label: item,
    value: item,
  }))
}

// classified as page

export const classifiedAsTableColumns = [
  {
    id: 'classified-as',
    label: 'Classified As',
    headerStyle: 'min-w-100px',
  },
  {
    id: 'product-count',
    label: 'Product Count',
    headerStyle: 'min-w-100px',
  },
  {
    id: 'action',
    label: 'Action',
    headerStyle: 'w-80px',
  },
]

export const classifiedAsTableRowData = (row: any) => {
  return {
    id: row?.id,
    classifiedAs: row?.name || '-',
    productCount: row?.product_count || 0,
  }
}

export const parseClassificationTableRowData = (row: any) => {
  return {
    id: row?.id || '',
    sku: row?.sku || '-',
    product_title: row?.product_title || '-',
    old_classification: row?.old_classification || '-',
    new_classification: row?.new_classification || '',
    created_by: row?.created_by || '-',
    created_at: row?.created_at || '',
    thumbnail_url: row?.thumbnail_url || defaultImage,
  }
}

// Incoming Report parsing functions
export const parseIncomingReportRowData = (row: any) => {
  if (!row) return {}

  return {
    parent_sku: row.parent_sku || '',
    product_title: row.product_title || '',
    thumbnail_url: row.thumbnail_url || '',
    quantity_incoming: row.quantity_incoming || 0,
    recordable_quantity: row.recordable_quantity || 0,
    deficit_quantity: row.deficit_quantity || 0,
    child_data: row.child_data || [],
  }
}

export const parseIncomingReportChildRowData = (row: any) => {
  if (!row) return {}

  return {
    child_sku: row.child_sku || '',
    product_title: row.product_title || '',
    thumbnail_url: row.thumbnail_url || '',
    quantity_incoming: row.quantity_incoming || 0,
    recordable_quantity: row.recordable_quantity || 0,
    deficit_quantity: row.deficit_quantity || 0,
  }
}

// Incoming Report default filters
export const DEFAULT_INCOMING_REPORT_FILTERS = {
  primary_supplier: '',
  classification: '',
  brands: '',
  tags: '',
  show_zero_incoming: false,
  classified_as: '',
}

// Incoming Report Filters Configuration
export const INCOMING_REPORT_FILTERS = (tableFilters: any, watchData: any) => [
  {
    id: 'primary_supplier',
    isMultiSelect: true,
    registerKey: 'primary_supplier',
    label: 'Primary Supplier',
    placeholder: 'Select Primary Supplier',
    options:
      tableFilters?.primary_supplier?.map((supplier: string) => ({
        label: supplier,
        value: supplier,
      })) || [],
    ...(!watchData?.primary_supplier && {selectedValues: []}),
  },
  {
    id: 'classification',
    isMultiSelect: true,
    registerKey: 'classification',
    label: 'Classification',
    placeholder: 'Select Classification',
    options:
      tableFilters?.classification?.map((classification: string) => ({
        label: classification,
        value: classification,
      })) || [],
    ...(!watchData?.classification && {selectedValues: []}),
  },
  {
    id: 'brands',
    isMultiSelect: true,
    registerKey: 'brands',
    label: 'Brands',
    placeholder: 'Select Brands',
    options:
      tableFilters?.brand?.map((brand: string) => ({
        label: brand,
        value: brand,
      })) || [],
    ...(!watchData?.brands && {selectedValues: []}),
  },
  // {
  //   id: 'tags',
  //   isMultiSelect: true,
  //   registerKey: 'tags',
  //   label: 'Tags',
  //   placeholder: 'Select Tags',
  //   options:
  //     tableFilters?.tags?.map((tag: any) => ({
  //       label: tag.tag,
  //       value: tag.id,
  //     })) || [],
  //   ...(!watchData?.tags && {selectedValues: []}),
  // },
]

// Incoming Report form data to filters conversion
export const formIncomingReportDataToFiltersValue = (data: any) => {
  return {
    primary_supplier: makeSemicolonSepratedValues(data?.primary_supplier),
    classification: makeSemicolonSepratedValues(data?.classification),
    brands: makeSemicolonSepratedValues(data?.brands),
    tags: makeSemicolonSepratedValues(data?.tags),
    classified_as: makeSemicolonSepratedValues(data?.classified_as),
    show_zero_incoming: data?.show_zero_incoming || false,
    search_value: data?.search || '',
  }
}

// Incoming Report table columns configuration
export const incomingReportTableColumns = (isChild: boolean) => {
  return [
    ...(!isChild
      ? [
          {
            key: 'checkbox',
            label: '',
            isSorted: false,
            headerStyle: 'min-w-60px w-60px',
          },
        ]
      : []),
    {
      key: 'child_data',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-50px w-50px',
    },
    {
      key: 'product_title',
      label: 'Product',
      isSorted: true,
      headerStyle: 'min-w-300px w-300px',
    },
    {
      key: 'parent_sku',
      label: 'SKU',
      isSorted: true,
      headerStyle: 'min-w-150px w-150px',
    },
    {
      key: 'quantity_incoming',
      label: 'Incoming Quantity',
      isSorted: true,
      headerStyle: 'min-w-150px w-150px text-center',
      style: 'justify-content-center',
    },
    {
      key: 'recordable_quantity',
      label: 'Recordable Quantity/Received',
      isSorted: true,
      headerStyle: 'min-w-200px w-200px text-center',
      style: 'justify-content-center',
    },
    {
      key: 'deficit_quantity',
      label: 'Deficit Quantity/To be Received',
      isSorted: true,
      headerStyle: 'min-w-200px w-200px text-center border-end',
      style: 'justify-content-center',
    },
    ...(isChild
      ? [
          {
            key: 'action',
            label: 'Action',
            isSorted: false,
            headerStyle: 'w-75px',
          },
        ]
      : []),
  ]
}

// Incoming Report Parent Table Sortable Columns
export const incomingReportParentTableColumns = () => {
  return [
    {
      key: 'child_data',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-60px w-60px head-col-sticky',
    },
    {
      key: 'product_title',
      label: 'Product',
      isSorted: true,
      headerStyle: 'min-w-400px w-400px head-col-sticky',
    },
    {
      key: 'parent_sku',
      label: 'SKU',
      isSorted: true,
      headerStyle: 'min-w-150px w-150px head-col-sticky',
    },
    {
      key: 'total_quantity_incoming',
      label: 'Incoming QTY',
      isSorted: true,
      headerStyle: 'min-w-125px w-125px text-center head-col-sticky',
      style: 'justify-content-center',
      isColumnTotal: true,
    },
    {
      key: 'total_recordable_qty',
      label: 'Recordable QTY',
      isSorted: true,
      headerStyle: 'min-w-150px w-150px text-center head-col-sticky',
      style: 'justify-content-center',
      isColumnTotal: true,
    },
    {
      key: 'total_deficit_qty',
      label: 'Deficit QTY',
      isSorted: true,
      headerStyle: 'min-w-100px w-100px text-center border-end head-col-sticky',
      style: 'justify-content-center',
      isColumnTotal: true,
    },
    {
      key: 'action',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-100px w-100px text-center',
      style: 'd-flex justify-content-center',
    },
  ]
}

// Incoming Report Child Table Sortable Columns
export const incomingReportChildTableColumns = (hasWritePermission: boolean) => {
  return [
    ...(hasWritePermission
      ? [
          {
            key: 'checkbox',
            label: '',
            isSorted: false,
            headerStyle: 'min-w-60px w-60px head-col-sticky',
          },
        ]
      : []),
    {
      key: 'title',
      label: 'Product',
      isSorted: false,
      headerStyle: 'min-w-400px w-400px head-col-sticky',
    },
    {
      key: 'sku',
      label: 'SKU',
      isSorted: false,
      headerStyle: 'min-w-150px w-150px head-col-sticky',
    },
    {
      key: 'quantity_incoming',
      label: 'Incoming QTY',
      isSorted: false,
      headerStyle: 'min-w-125px w-125px text-center head-col-sticky',
      style: 'justify-content-center',
    },
    {
      key: 'recordable_qty',
      label: 'Recordable QTY',
      isSorted: false,
      headerStyle: 'min-w-150px w-150px text-center head-col-sticky',
      style: 'justify-content-center',
    },
    {
      key: 'deficit_qty',
      label: 'Deficit QTY',
      isSorted: false,
      headerStyle: 'min-w-100px w-100px text-center head-col-sticky',
      style: 'justify-content-center',
    },
    {
      key: 'action',
      label: 'Action',
      isSorted: false,
      headerStyle: 'min-w-100px w-100px text-center',
      style: 'd-flex justify-content-center',
    },
  ]
}

// Generate calendar columns for incoming report
export const generateIncomingReportCalendarColumns = (monthly_column: any) => {
  const columns: any[] = []
  const dayKeys = Object.keys(monthly_column).sort((a, b) => {
    const dayA = parseInt(a.replace('day_', ''))
    const dayB = parseInt(b.replace('day_', ''))
    return dayA - dayB
  })

  dayKeys.forEach((dayKey, index) => {
    const dayData = (monthly_column as any)[dayKey]

    // Check if this is the first day of the month (day 1)
    const isFirstDayOfMonth = dayData.date && dayData.date.endsWith('-01')

    let headerContent = ''
    if (isFirstDayOfMonth) {
      // Show month name and day for first day of month
      const monthYear = dayData.label.split(' ').slice(2).join(' ') // Extract "AUGUST 2025"
      const dayInfo = dayData.label.split(' ').slice(0, 2).join(' ') // Extract "FRI 01"
      headerContent = `
        <div class="text-dark">${monthYear}</div>
        <div class="text-muted fs-7">${dayInfo}</div>
      `
    } else {
      // Show only day info for other days
      const dayInfo = dayData.label.split(' ').slice(0, 2).join(' ') // Extract "SAT 02", "SUN 03", etc.
      headerContent = `
        <div class="text-muted fs-7">${dayInfo}</div>
      `
    }

    columns.push({
      key: dayKey,
      label: headerContent,
      isSorted: false,
      headerStyle: `min-w-120px w-120px text-center ${dayData.isWeekend ? 'bg-light' : ''} ${
        isFirstDayOfMonth ? 'border-start' : ''
      }`,
      style: 'justify-content-center',
      dayData: dayData,
    })
  })

  return columns
}

// Get day totals for incoming report
export const getIncomingReportDayTotal = (dayKey: string, total_calender_data: any) => {
  if (!total_calender_data || !Object.keys(total_calender_data).length) return '-'

  const dayData = formatToIndianNumber(total_calender_data[dayKey])
  return dayData ? dayData || '-' : '-'
}

export function makeSemicolonSerratedValues(input: any) {
  if (input?.length && Array.isArray(input)) {
    return input?.join(';')
  } else {
    return ''
  }
}

// Sample incoming report CSV data
export const SAMPLE_INCOMING_REPORT_CSV_DATA = [
  {
    'Product Name': 'Product 1',
    SKU: '1234567890',
    '01-21-2025': '10',
    '01-22-2025': '20',
    '01-23-2025': '30',
    '01-24-2025': '40',
    '01-25-2025': '50',
    '01-26-2025': '60',
    '01-27-2025': '70',
  },
  {
    'Product Name': 'Product 2',
    SKU: '1234567891',
    '01-21-2025': '10',
    '01-22-2025': '20',
    '01-23-2025': '30',
    '01-24-2025': '40',
    '01-25-2025': '50',
    '01-26-2025': '60',
    '01-27-2025': '70',
  },
  {
    'Product Name': 'Product 3',
    SKU: '1234567892',
    '01-21-2025': '10',
    '01-22-2025': '20',
    '01-23-2025': '30',
    '01-24-2025': '40',
    '01-25-2025': '50',
    '01-26-2025': '60',
    '01-27-2025': '70',
  },
  {
    'Product Name': 'Product 4',
    SKU: '1234567893',
    '01-21-2025': '10',
    '01-22-2025': '20',
    '01-23-2025': '30',
    '01-24-2025': '40',
    '01-25-2025': '50',
    '01-26-2025': '60',
    '01-27-2025': '70',
  },
  {
    'Product Name': 'Product 5',
    SKU: '1234567894',
    '01-21-2025': '10',
    '01-22-2025': '20',
    '01-23-2025': '30',
    '01-24-2025': '40',
    '01-25-2025': '50',
    '01-26-2025': '60',
    '01-27-2025': '70',
  },
]

// Expected date format pattern (MM-DD-YYYY) - 4 digit year
const EXPECTED_DATE_FORMAT = /^(\d{2})-(\d{2})-(\d{4})$/

// Validate if a date string is in the correct format and represents a valid date
function isValidDate(dateStr: string): boolean {
  const match = dateStr.match(EXPECTED_DATE_FORMAT)
  if (!match) return false

  const month = parseInt(match[1], 10)
  const day = parseInt(match[2], 10)
  const year = parseInt(match[3], 10)

  // Basic range checks
  if (month < 1 || month > 12) return false
  if (day < 1 || day > 31) return false
  if (year < 0 || year > 9999) return false // 4-digit year range

  // Create date and check if it's valid
  const date = new Date(year, month - 1, day)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

// Parse Incoming Report CSV and validate data
export function parseCsvValidateAndSet(
  file: File,
  setErrors: React.Dispatch<React.SetStateAction<ValidationError[]>>,
  setShowErrors: React.Dispatch<React.SetStateAction<boolean>>
): Promise<{csvData: Array<Record<string, any>>}> {
  return new Promise((resolve) => {
    // Clear previous outcomes optimistically
    setErrors([])
    setShowErrors(false)

    Papa.parse<Record<string, any>>(file, {
      header: true,
      skipEmptyLines: 'greedy',
      dynamicTyping: true,
      worker: true,
      complete: (results) => {
        const rows = (results.data || []) as Array<Record<string, any>>

        // Defensive: no rows
        if (!rows.length) {
          setErrors([])
          setShowErrors(false)
          resolve({csvData: []})
          return
        }

        // Check if more than 100 rows
        if (rows.length > 100) {
          setErrors([
            {
              type: 'EXCEEDED_ROWS_LIMIT',
              message: `Too many rows. Maximum allowed is 100, but found ${rows.length} rows.`,
              rows: rows.length,
            },
          ])
          setShowErrors(true)
          resolve({csvData: []})
          return
        }

        // Enhanced header validation including date format validation
        const headerKeys = Object.keys(rows[0] || {})
        const dateHeaderErrors: ValidationError[] = []

        // Check first two columns
        if (headerKeys.length >= 2) {
          const firstColumn = headerKeys[0]?.trim() || ''
          const secondColumn = headerKeys[1]?.trim() || ''

          // Validate first column (Product Name) - only check header name
          if (!firstColumn.toLowerCase().includes('product')) {
            dateHeaderErrors.push({
              type: 'INVALID_HEADER',
              message: `First column should be 'Product Name', found: <b>'${firstColumn}'</b>`,
              column: firstColumn,
            })
          }

          // Validate second column (SKU) - only check header name
          if (!secondColumn.toLowerCase().includes('sku')) {
            dateHeaderErrors.push({
              type: 'INVALID_HEADER',
              message: `Second column should be 'SKU', found: <b>'${secondColumn}'</b>`,
              column: secondColumn,
            })
          }
        }

        // All columns from 3rd onwards must be valid date columns in MM-DD-YY format
        for (let i = 2; i < headerKeys.length; i++) {
          const header = headerKeys[i]?.trim() || ''

          if (!header) {
            dateHeaderErrors.push({
              type: 'INVALID_HEADER',
              message: `Empty header found in column no. ${i + 1}`,
              column: `Column ${i + 1}`,
            })
            continue
          }

          // Check if header is in MM-DD-YY format
          if (!EXPECTED_DATE_FORMAT.test(header)) {
            dateHeaderErrors.push({
              type: 'INVALID_HEADER',
              message: `Column no. ${
                i + 1
              } header: '${header}' is not a valid date. Expected format: <b>MM-DD-YYYY</b>`,
              column: header,
            })
            continue
          }

          // Validate the date is valid
          if (!isValidDate(header)) {
            dateHeaderErrors.push({
              type: 'INVALID_HEADER',
              message: `Column no. ${
                i + 1
              } has invalid date: '${header}'. Date doesn't exist or is in an invalid format. Expected format: <b>MM-DD-YYYY</b>`,
              column: header,
            })
          }
        }

        // Validate date headers format
        if (dateHeaderErrors.length > 0) {
          setErrors(dateHeaderErrors)
          setShowErrors(true)
          resolve({csvData: []})
          return
        }

        // Resolve the actual "SKU" header (case-insensitive)
        const skuKey = headerKeys.find((k) => k?.trim().toLowerCase() === 'sku')
        if (!skuKey) {
          setErrors([
            {
              type: 'MISSING_SKU',
              message: 'Missing "SKU" column (case-insensitive match).',
            },
          ])
          setShowErrors(true)
          resolve({csvData: []})
          return
        }

        // ----- Check 1: Duplicate SKUs and Empty SKUs -----
        const skuPositions = new Map<string, {positions: number[]; rowObjects: any[]}>() // sku -> positions and row objects
        const emptySkuErrors: ValidationError[] = []

        for (let i = 0; i < rows.length; i++) {
          const sku = String(rows[i]?.[skuKey] ?? '').trim()

          // Check for empty SKU
          if (!sku) {
            emptySkuErrors.push({
              type: 'INVALID_SKU',
              message: 'SKU is missing.',
              sku: '!Empty',
              rows: [i + 2],
            })
            continue
          }

          if (!skuPositions.has(sku)) {
            skuPositions.set(sku, {positions: [], rowObjects: []})
          }
          const skuData = skuPositions.get(sku)!
          skuData.positions.push(i + 2) // Store 1-based row numbers directly
          skuData.rowObjects.push(rows[i])
        }

        // Check for duplicate SKUs
        const duplicateErrors: ValidationError[] = []
        const skuEntries = Array.from(skuPositions.entries())
        for (let j = 0; j < skuEntries.length; j++) {
          const [sku, skuData] = skuEntries[j]
          if (skuData.positions.length > 1) {
            const err: ValidationError = {
              type: 'INVALID_SKU',
              message: `Duplicate SKU found.`,
              sku,
              rows: skuData.positions,
            }
            duplicateErrors.push(err)
          }
        }

        // Combine empty SKU and duplicate errors
        const skuErrors = [...emptySkuErrors, ...duplicateErrors]
        if (skuErrors.length) {
          setErrors(skuErrors)
          setShowErrors(true)
          resolve({csvData: []})
          return // early exit per requirement
        }

        // Only validate date columns (from 3rd column onwards), not Product Name or SKU
        const productNameKey = headerKeys[0]
        const dateColumns = headerKeys.filter((k) => k !== skuKey && k !== productNameKey)
        const errors: ValidationError[] = []
        const nonNegIntStr = /^(0|[1-9]\d*)$/ // allows 0, positive integers, disallows negatives, decimals, non-numeric
        const processedRows: Array<Record<string, any>> = []

        // Use the row objects from skuPositions to avoid another loop
        for (const [sku, skuData] of skuEntries) {
          const row = skuData.rowObjects[0]
          const rowIndex = skuData.positions[0] - 1
          const processedRow: Record<string, any> = {}
          if (productNameKey) {
            processedRow[productNameKey] = row[productNameKey]
          }
          processedRow[skuKey] = sku

          // Only validate and include date columns (not Product Name or SKU)
          for (let c = 0; c < dateColumns.length; c++) {
            const col = dateColumns[c]
            const v = row[col]

            // Skip empty/null/undefined values - don't include in object
            if (v === null || v === undefined || v === '') {
              continue
            }

            // Fast path for numbers
            let ok = false
            if (typeof v === 'number') {
              ok = Number.isInteger(v) && v >= 0
            } else if (typeof v === 'string') {
              const trimmed = v.trim()
              if (trimmed === '') {
                continue // Skip empty strings
              }
              ok = nonNegIntStr.test(trimmed)
            } else {
              ok = false // other types
            }

            if (!ok) {
              errors.push({
                type: 'INVALID_CELL',
                message: `Invalid value (must be a non-negative integer).`,
                sku,
                row: rowIndex + 1,
                column: col,
                value: v,
              })
            } else {
              // Include valid values in the processed row
              processedRow[col] = v
            }
          }

          processedRows.push(processedRow)
        }

        if (errors.length) {
          setErrors(errors)
          setShowErrors(true)
          resolve({csvData: []})
          return
        }

        // All good — return validated data
        setErrors([])
        setShowErrors(false)
        resolve({csvData: processedRows})
      },
      error: (err) => {
        setErrors([{type: 'CSV_PARSE_ERROR', message: err?.message || 'Failed to parse CSV.'}])
        setShowErrors(true)
        resolve({csvData: []})
        return
      },
    })
  })
}

// format error list for incoming report csv import error modal
export const getErrorList = (csvErrors: ValidationError[]) => {
  const errorList: Array<{
    sku: string
    message: string
    row?: number
    column?: string
    value?: string
    isSingleMessage?: boolean
  }> = []

  csvErrors.forEach((error) => {
    if (error.type === 'INVALID_SKU') {
      // For invalid SKU errors, create an entry for each row
      error.rows.forEach((row) => {
        errorList.push({
          sku: error.sku,
          message: error.message,
          row: row,
        })
      })
    } else if (error.type === 'INVALID_CELL') {
      // For invalid cell errors, create a single entry with row, column, and value
      errorList.push({
        sku: error.sku,
        message: error.message,
        row: error.row,
        column: error.column,
        value: String(error.value),
      })
    } else if (
      error.type === 'MISSING_SKU' ||
      error.type === 'CSV_PARSE_ERROR' ||
      error.type === 'EXCEEDED_ROWS_LIMIT' ||
      error.type === 'INVALID_HEADER'
    ) {
      // For parse errors, missing column, too many rows, and invalid header errors, create a single entry
      errorList.push({
        sku: 'N/A',
        message: error.message,
        isSingleMessage: true,
      })
    }
  })

  return errorList
}
